import {
  BasketItemType,
  mockBasket,
  mockBasketCustomerDetails,
} from '@domgen/dgx-fe-basket';
import { CreateBasketItemOrAddCLPQuoteToBasketResponse } from '../../models/basket/create-basket-item-or-add-clp-quote-to-basket-response.interface';

export const mockCreateBasketItemOrAddCLPQuoteToBasketResponse: CreateBasketItemOrAddCLPQuoteToBasketResponse =
  {
    basket: mockBasket,
    requestedItemType: BasketItemType.Quote,
    customer: mockBasketCustomerDetails,
  };
